import { Link } from 'react-router-dom';

const stats = [
  { value: '12000+', label: '影视资源' },
  { value: '每日', label: '持续更新' },
  { value: '4K', label: '高清画质' },
  { value: '多模式', label: '播放体验' },
];

export default function SiteIntro() {
  return (
    <section className="w-full px-4 md:px-8 py-12 md:py-16">
      <div className="relative rounded-xl overflow-hidden border border-background-200 bg-background-100">
        <div className="grid grid-cols-1 lg:grid-cols-2">
          <div className="p-6 md:p-10 lg:p-12">
            <span className="inline-flex items-center gap-2 text-xs font-medium text-accent-300 bg-accent-950/60 border border-accent-800/50 px-3 py-1 rounded-full">
              <i className="ri-sparkling-2-line"></i>
              关于香蕉视频app
            </span>
            <h2 className="mt-4 font-heading font-bold text-2xl md:text-3xl text-foreground-50 leading-snug">
              高清影视，一触即达
            </h2>
            <p className="mt-4 text-sm md:text-base text-foreground-300 leading-relaxed">
              香蕉视频app 致力于为影视爱好者提供一站式的高清影视信息浏览与观看指导。从院线新片到口碑剧集，从国剧精选到海外佳作，
              我们用清晰的分类、高效的检索和丰富的标签，帮你以最短的时间找到最想看的那一部。
            </p>
            <div className="mt-8 grid grid-cols-2 sm:grid-cols-4 gap-4">
              {stats.map((stat) => (
                <div key={stat.label}>
                  <p className="font-heading font-extrabold text-xl md:text-2xl text-primary-400">{stat.value}</p>
                  <p className="text-xs text-foreground-500 mt-1">{stat.label}</p>
                </div>
              ))}
            </div>
            <div className="mt-8 flex flex-wrap items-center gap-3">
              <Link
                to="/category/movie"
                className="inline-flex items-center gap-2 h-11 px-6 rounded-md bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-compass-3-line text-lg"></i>
                开始探索片库
              </Link>
              <Link
                to="/about"
                className="inline-flex items-center gap-2 h-11 px-6 rounded-md border border-foreground-600 text-foreground-100 text-sm font-semibold hover:bg-background-200/70 transition-colors cursor-pointer whitespace-nowrap"
              >
                了解更多
              </Link>
            </div>
          </div>

          <div className="relative min-h-[220px] lg:min-h-full">
            <img
              src="https://readdy.ai/api/search-image?query=Artistic%20cinematic%20collage%20of%20film%20and%20television%20themes%20with%20warm%20yellow%20and%20orange%20lighting%2C%20film%20reels%2C%20projector%20light%20beams%2C%20dark%20moody%20background%2C%20premium%20editorial%20style%2C%20no%20text&width=1000&height=1000&seq=banana-intro-01&orientation=squarish"
              alt="香蕉视频app 影视内容氛围图"
              title="香蕉视频app - 海量高清影视资源"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-background-100 via-background-100/30 to-transparent lg:bg-gradient-to-r lg:from-background-100 lg:via-transparent"></div>
          </div>
        </div>
      </div>
    </section>
  );
}